import { useTranslation } from 'react-i18next';
import { DatePicker } from '../../../atoms/DatePicker';
import * as Styled from './RecurringEndDate.styled';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const RecurringEndDate = ({
  handleDatePickerChange
}) => {
  const {
    t
  } = useTranslation('blocks.donation');
  return /*#__PURE__*/_jsxs(Styled.RecurringEndDateContainer, {
    children: [/*#__PURE__*/_jsx("span", {
      children: t('RecurringEndDate.endDateOptional', 'End date (optional)')
    }), /*#__PURE__*/_jsx(DatePicker, {
      "data-id": "cp-donation-form-recurring-end-date",
      disablePastDates: true,
      onChangeCallback: recurringEndDate => {
        handleDatePickerChange(recurringEndDate);
      }
    })]
  });
};